import { Client, ScenarioSettings } from "src/types";
import { getTaxRate, yearRange } from "../../utils";
import MainChart from ".././Charts/MainChart";
import Header from "../Report/Header";
import { useScenario } from "src/hooks/useScenario";
import { useUser } from "src/hooks/useUser";

interface MapChartProps {
  settings: ScenarioSettings;
  client: Client;
  print?: boolean;
}

const ByPersonChart = ({ settings, client, print }: MapChartProps) => {
  const incomes = settings.incomes.filter((inc) => inc.enabled);
  const { user } = useUser();
  const startYear = new Date().getFullYear();
  const { scenario } = useScenario();

  const groupedIncomesByTaxType = incomes.reduce(
    (acc, income) => {
      const key = income.personId;
      if (!acc[key]) acc[key] = [];
      acc[key].push(income);
      return acc;
    },
    client.people.length > 1 ? ({ 0: [], 1: [], "-1": [] } as any) : { 0: [] },
  );
  const sorted = Object.keys(groupedIncomesByTaxType).sort((a, b) => {
    return parseInt(b) - parseInt(a);
  });
  console.log("ss", sorted);

  return (
    <div className={`bg-white ${!print && "pb-5"} ${print && "mr-5"}`}>
      <Header client={client as any} scenario={settings} page="Incomes" />
      <MainChart
        years={yearRange(startYear, startYear + settings.maxYearsShown - 1)}
        spending={false}
        initialHeight={print ? 660 : 550}
        longevityFlag={!!user?.info?.longevityFlag}
        people={client.people}
        lineData={[]}
        taxes={[]}
        stability={!!user?.info?.stabilityRatioFlag}
        needsFlag={false}
        stackedData={sorted.map((key) => {
          return {
            name:
              key === "-1"
                ? "Joint"
                : client.people.find((p) => p.id === parseInt(key))?.name ||
                  "Unknown",
            stable: true,
            values: yearRange(
              startYear,
              startYear + settings.maxYearsShown - 1,
            ).map((year) => {
              const income = groupedIncomesByTaxType[key]
                .map((income: any) => scenario[year]?.incomes[income.id].amount)
                .filter((t: any) => typeof t === "number")
                .reduce((a: any, b: any) => a + b, 0);
              const taxRate = getTaxRate(user, settings, year);
              return income * (1 - taxRate);
            }),
          };
        })}
      />
    </div>
  );
};

export default ByPersonChart;
